/* Supply › Reports › Purchase Reports — hub of purchase sub-reports. */
import React from "react";
import { ReportHub } from "./reportShared";
import { PHARMACY_ROUTES } from "../../../Route/path";

const CARDS = [
  {
    title: "GRN Report (Datewise)",
    desc: "Item-level GRN lines received in a date window — batch, tax and margin, with CSV download.",
    path: PHARMACY_ROUTES.PURCHASE_REPORT_GRN_DATEWISE,
  },
  {
    title: "Purchase Register",
    desc: "Detailed view of all inward purchases (GRNs) by supplier, warehouse, and date.",
    path: PHARMACY_ROUTES.PURCHASE_REPORT_REGISTER,
  },
  {
    title: "Supplier-wise Purchase",
    desc: "Purchase totals grouped by supplier over a date range.",
    path: PHARMACY_ROUTES.PURCHASE_REPORT_SUPPLIER,
  },
  {
    title: "Purchase Orders",
    desc: "Purchase orders raised, by status and supplier.",
    path: PHARMACY_ROUTES.PURCHASE_REPORT_ORDERS,
  },
];

const PurchaseReport = () => (
  <ReportHub title="Purchase Reports" sub="Purchase registers, supplier splits, and orders" cards={CARDS} />
);

export default PurchaseReport;
